module.exports = __webpack_public_path__ + "images/feature/20190604-d211669fe8376fe23661a60fbb47628b.png";